import { getMeta, updateMeta } from '../admin-api';
import type { MetaValues } from '../admin-api';
import { formField } from '../admin-ui';
import { cmsErrorText } from './admin-cms';

const META_FIELDS: Array<{ key: keyof MetaValues; label: string }> = [
  { key: 'title', label: 'Title' },
  { key: 'description', label: 'Description' },
  { key: 'site_name', label: 'Site Name' },
  { key: 'url', label: 'URL' },
  { key: 'locale', label: 'Locale' },
  { key: 'image', label: 'OG Image URL' },
  { key: 'image_alt', label: 'Image Alt' },
  { key: 'twitter_card', label: 'Twitter Card' },
];

export async function mountMeta(container: HTMLElement): Promise<() => void> {
  let values: MetaValues | null = null;

  try {
    const res = await getMeta();
    values = res.values;
  } catch {
    container.innerHTML = '<p class="text-red-400 p-4">Failed to load meta.</p>';
    return () => {};
  }

  function render(): void {
    if (!values) return;
    container.innerHTML = `
      <h2 class="font-heading text-gold text-lg mb-4">SEO / Meta Tags</h2>
      <div class="frame-pewter p-4">
        ${META_FIELDS.map(f => formField(f.label, `adm-meta-${f.key}`, 'text', values![f.key] ?? '')).join('')}
        <button id="adm-meta-save" class="btn btn-gold min-h-11 px-4 text-sm mt-2">Save</button>
        <span id="adm-meta-msg" class="text-[13px] text-muted ml-3"></span>
      </div>
    `;
    wire();
  }

  function wire(): void {
    container.querySelector('#adm-meta-save')?.addEventListener('click', async () => {
      const data: Record<string, string | null> = {};
      for (const f of META_FIELDS) {
        const input = container.querySelector<HTMLInputElement>(`#adm-meta-${f.key}`);
        data[f.key] = input?.value.trim() ?? '';
      }
      const msg = container.querySelector('#adm-meta-msg');
      try {
        await updateMeta(data);
        if (msg) { msg.textContent = 'Saved.'; msg.classList.remove('text-red-400'); }
      } catch (err) {
        if (msg) { msg.textContent = `Save failed: ${cmsErrorText(err)}`; msg.classList.add('text-red-400'); }
      }
    });
  }

  render();
  return () => {};
}
